
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trait-swapper",
      function () {
        return require("private-next-pages/trait-swapper/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trait-swapper"])
      });
    }
  